import { render, staticRenderFns } from "./GroupUsers.vue?vue&type=template&id=60328cdf&"
import script from "./GroupUsers.vue?vue&type=script&lang=ts&"
export * from "./GroupUsers.vue?vue&type=script&lang=ts&"
import style0 from "./GroupUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports